<template>
  <div class="ContentCss">
    <el-card>
      <el-form ref="form" label-width="80px" size="mini" :inline="true">
        <el-form-item label="句子">
          <el-input v-model="keys"></el-input>
        </el-form-item>
        <el-form-item label="句式类型">
          <el-select v-model="vtype">
            <el-option
              v-for="(item, i) in vtypeList"
              :key="i"
              :value="item.vtype"
              :label="item.vtype"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="内容">
          <el-input v-model="replaceword"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="HandelFun('search')"
            >搜索</el-button
          >
          <el-button type="primary" @click="HandelFun('add')">新增</el-button>
          <el-button type="primary" @click="HandelFun('delList')"
            >批量删除</el-button
          >
          <!-- <el-button type="primary" @click="HandelFun('import')"
            >导入</el-button
          > -->
          <el-upload
            style="display:inline-block;margin-left:10px"
            ref="upload"
            accept=".xls,.xlsx"
            action="https://jsonplaceholder.typicode.com/posts/"
            :on-change="upload"
            :show-file-list="false"
            :auto-upload="false"
          >
            <!-- 导入的excel表格和展示的表头名el-table的prop对应 -->
            <el-button type="primary">导入</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card>
      <el-table
        :data="tableData"
        style="width: 100%"
        size="mini"
        align="center"
        @selection-change="delList"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <!-- <el-table-column label="" width="50"
          ><template scope="{row}"
            ><input type="checkbox" v-model="row.isdel" @change="delList(row)"
          /></template>
        </el-table-column> -->
        <el-table-column prop="sentence" label="句子"> </el-table-column>
        <el-table-column prop="vtype" label="句式类型"> </el-table-column>
        <el-table-column prop="scode" label="句式代码"> </el-table-column>
        <el-table-column prop="replaceword" label="内容"> </el-table-column>
        <!-- <el-table-column label="是否定序">
          <template slot-scope="scope">
            <el-switch
              :value="scope.row.sort == 1 ? true : false"
              active-color=" #13ce66"
              inactive-color="#ff4949"
            >
            </el-switch>
          </template>
        </el-table-column> -->
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="HandelFun('edit', scope.row)"
              >编辑</el-button
            >
            <el-button type="text" size="small" @click="HandelDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next,sizes"
        :total="allCount"
        :page-size="10"
        :page-sizes="[10, 20, 30, 50]"
        @current-change="CurrentChange"
        @size-change="handleSizeChange"
      >
      </el-pagination>
    </el-card>
    <el-dialog
      :title="isAdd ? '新增' : '编辑'"
      :visible.sync="dialogTableVisible"
      size="mini"
      center
      :before-close="BeforeCloseFun"
    >
      <el-form label-width=" 80px" size="mini" class="DialogCss">
        <el-form-item label="句子">
          <el-input v-model.trim="EditObj.sentence"></el-input>
        </el-form-item>
        <el-form-item label="句式类型">
          <el-select v-model="EditObj.vtype">
            <el-option
              v-for="(item, i) in vtypeList"
              :key="i"
              :value="item.vtype"
              :label="item.vtype"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="句式代码">
          <el-input v-model.trim="EditObj.scode"></el-input>
        </el-form-item>
        <!-- <el-form-item label="是否定序">
          <el-switch
            v-model="EditObj.sort"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>
        </el-form-item> -->
        <el-form-item label="词槽列表">
          <el-button type="primary" @click="EditListHandel('add')">
            新增</el-button
          >
        </el-form-item>
        <el-form-item
          :label="Filter(index)"
          v-for="(items, index) in EditObj.list"
          :key="items.id"
        >
          <div class="FIEX">
            <el-select v-model="items.keyword" filterable>
              <el-option
                v-for="item2 in keywordsList"
                :label="item2.keyword"
                :value="item2.keyword"
                :key="item2.tid"
              >
              </el-option>
            </el-select>
            <el-form-item
              label="间隔"
              v-show="index != EditObj.list.length - 1"
            >
              <el-input-number
                v-model="items.count"
                :min="1"
                label="请输入文字间隔"
              >
              </el-input-number>
            </el-form-item>
            <el-form-item>
              <el-button type="danger" @click="EditListHandel('del', items.tid)"
                >删除</el-button
              >
            </el-form-item>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="HandelFun('cancel')" size="mini">取 消</el-button>
        <el-button type="primary" @click="HandelFun('save')" size="mini"
          >保 存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import XLSX from "../../utils/xlsx.core.min.js";
export default {
  data() {
    return {
      keys: "",
      vtype: "",
      replaceword: "",
      vtypeList: [],
      tableData: [],
      tidList: [],
      dialogTableVisible: false,
      allCount: 1, // 条数
      pageindex: 1, // 页码
      pagesize: 10,
      isAdd: false,
      keywordsList: [],
      EditObj: {
        tid: "",
        sentence: "", // 句意
        vtype: "",
        scode: "",
        // sort: 1, // 是否定序
        list: []
      },
      getexcelData: []
    };
  },
  methods: {
    delList(val) {
      console.log(val);
      this.tidList = val.map(item => item.tid);
      // if (val.del) {
      //   this.tidList.splice(
      //     this.tidList.findIndex(item => item == val.tid),
      //     1
      //   );
      // } else {
      //   this.tidList.push(val.tid);
      // }
    },
    upload(file, filess) {
      let files = { 0: file.raw };
      this.readExcel(files);
    },
    // 读取 excel文件
    readExcel(files) {
      // 表格导入
      var that = this;
      console.log(files);
      if (files.length <= 0) {
        // 如果没有文件名
        return false;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.$Message.error("上传格式不正确，请上传xls或者xlsx格式");
        return false;
      }

      const fileReader = new FileReader();
      fileReader.onload = async ev => {
        try {
          const data = ev.target.result;
          // console.log("data", data);
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0]; // 取第一张表
          console.log(wsname);
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); // 生成json表格内容
          const data1 = [];

          ws.forEach(item => {
            console.log(item);
            const data2 = {};
            Object.keys(item).forEach(item1 => {
              if (item1 == "句子") {
                data2["sentence"] = item[item1];
              } else if (item1 == "句式类型") {
                data2["vtype"] = item[item1];
              } else if (item1 == "句式代码") {
                data2["scode"] = item[item1];
              } else {
                data2["replaceword"] = item[item1];
              }
            });
            data1.push(data2);
          });
          console.log(data1, "data1是表格里的数据，且是json格式");
          this.addSentenceListFun(data1);
          // 重写数据

          this.$refs.upload.value = "";
        } catch (e) {
          console.log(e);
          return false;
        }
      };
      fileReader.readAsBinaryString(files[0]);
    },
    //增加数据
    // 获取句式类型
    getvtypeList() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let data = {};
      this.$axios
        .Postdata("manage/Voicerecordreport.asmx/getSentenceVtype", {
          data: JSON.stringify(this.$Help(data))
        })
        .then(res => {
          loading.close();
          this.vtypeList = res.data;
        });
    },
    // 页码函数
    CurrentChange(e) {
      this.pageindex = e;
      this.getSentenceFun();
    },
    handleSizeChange(e) {
      this.pagesize = e;
      this.getSentenceFun();
    },
    // 编辑列表
    EditListHandel(type, data) {
      if (type == "add") {
        this.EditObj.list.push({
          keyword: "",
          tid: new Date().getTime(),
          count: 1 // 间隔
        });
        return;
      }
      if (type == "del") {
        if (this.EditObj.list.length == 1) return;
        const idx = this.EditObj.list.findIndex(item => {
          return item.tid == data;
        });
        this.EditObj.list.splice(idx, 1);
        return;
      }
    },

    BeforeCloseFun(done) {
      done();
      this.EditObj = {
        tid: "",
        sentence: "", // 句意
        scode: "",
        // sort: false, // 是否定序
        list: []
      };
      return;
    },
    Filter(index) {
      return "词槽" + (index * 1 + 1);
    },
    // 操作按钮
    HandelFun(type, data) {
      if (type == "search") {
        this.pageindex = 1;
        this.getSentenceFun();
        return;
      }
      if (type == "delList") {
        this.HandelDelete({ tid: this.tidList.join(",") });
      }
      // if (type == "import") {this.
      //   console.log("导入");

      // const loading = this.$loading({
      //   lock: true,
      //   text: "Loading",
      //   spinner: "el-icon-loading",
      //   background: "rgba(0, 0, 0, 0.7)"
      // });
      // let data = {
      //   sentence: this.keys,
      //   vtype: this.vtype,
      //   pageindex: this.pageindex,
      //   pagesize: "0"
      // };
      // this.$axios
      //   .Postdata("manage/Voicerecordreport.asmx/getSentence", {
      //     data: JSON.stringify(this.$Help(data))
      //   })
      //   .then(res => {
      //     loading.close();
      //     this.tableData = res.data.detail;
      //     this.exportExcel(res.data.detail, "句式");
      //   });
      // }
      if (type == "edit") {
        console.log(data);
        this.EditObj.sentence = data.sentence;
        this.EditObj.vtype = data.vtype;
        this.EditObj.scode = data.scode;
        // this.EditObj.sort = Number(data.sort) ? true : false;
        this.EditObj.tid = data.tid;
        this.EditObj.list = [];
        let Array1 = data.replaceword.split(")");

        Array1.forEach((item, index) => {
          if (item) {
            let ItemArray = item.split("(");
            this.EditObj.list.push({
              keyword: ItemArray[0],
              tid: index * 1 + 1,
              count: ItemArray[1] // 间隔
            });
          }
        });

        this.isAdd = false;
        this.dialogTableVisible = true;
        return;
      }
      if (type == "add") {
        this.EditObj = {
          tid: "",
          sentence: "", // 句意
          vtype: "",
          scode: "",
          // sort: false, // 是否定序
          list: []
        };
        this.isAdd = true;
        this.dialogTableVisible = true;
        return;
      }
      if (type == "save") {
        if (this.EditObj.sentence && this.EditObj.list[0].keyword) {
          let idx = this.tableData.findIndex(item => {
            return item.sentence == this.EditObj.sentence;
          });
          if (idx == -1 || this.EditObj.tid) {
            console.log("提交");
            this.addSentenceFun();
          } else {
            this.$message({
              showClose: true,
              message: "已有句意名称，请勿重复添加",
              type: "error"
            });
          }
        } else {
          this.$message({
            showClose: true,
            message: "请填写完整后提交",
            type: "error"
          });
        }
        return;
      }
      if (type == "cancel") {
        this.dialogTableVisible = false;
        this.EditObj = {
          tid: "",
          sentence: "", // 句意
          vtype: "",
          scode: "",
          // sort: false, // 是否定序
          list: []
        };
        return;
      }
    },
    // // 表格下载方法
    // exportExcel(data, name) {
    //   let Tabledata = [["句子", "句子类型", "句子代码", "内容"]];
    //   data.forEach(item => {
    //     Tabledata.push([
    //       item.sentence,
    //       item.vtype,
    //       item.scode,
    //       item.replaceword
    //     ]);
    //   });
    //   // 下载数据  data   name:下载名字
    //   var sheet = XLSX.utils.aoa_to_sheet(Tabledata);
    //   this.openDownloadDialog(
    //     this.sheet2blob(sheet),
    //     `${name}${new Date().getTime()}.xlsx`
    //   );
    // },

    // // 将一个sheet转成最终的excel文件的blob对象，然后利用URL.createObjectURL下载
    // sheet2blob(sheet, sheetName) {
    //   sheetName = sheetName || "sheet1";
    //   var workbook = {
    //     SheetNames: [sheetName],
    //     Sheets: {}
    //   };
    //   workbook.Sheets[sheetName] = sheet;
    //   // 生成excel的配置项
    //   var wopts = {
    //     bookType: "xlsx", // 要生成的文件类型
    //     bookSST: false, // 是否生成Shared String Table，官方解释是，如果开启生成速度会下降，但在低版本IOS设备上有更好的兼容性
    //     type: "binary"
    //   };
    //   var wbout = XLSX.write(workbook, wopts);
    //   var blob = new Blob([s2ab(wbout)], {
    //     type: "application/octet-stream"
    //   });
    //   // 字符串转ArrayBuffer
    //   function s2ab(s) {
    //     var buf = new ArrayBuffer(s.length);
    //     var view = new Uint8Array(buf);
    //     for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
    //     return buf;
    //   }
    //   return blob;
    // },
    // // 导出方法
    // openDownloadDialog(url, saveName) {
    //   if (typeof url == "object" && url instanceof Blob) {
    //     url = URL.createObjectURL(url); // 创建blob地址
    //   }
    //   var aLink = document.createElement("a");
    //   aLink.href = url;
    //   aLink.download = saveName || ""; // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，file:///模式下不会生效
    //   var event;
    //   if (window.MouseEvent) event = new MouseEvent("click");
    //   else {
    //     event = document.createEvent("MouseEvents");
    //     event.initMouseEvent(
    //       "click",
    //       true,
    //       false,
    //       window,
    //       0,
    //       0,
    //       0,
    //       0,
    //       0,
    //       false,
    //       false,
    //       false,
    //       false,
    //       0,
    //       null
    //     );
    //   }
    //   aLink.dispatchEvent(event);
    // },
    HandelDelete(_data) {
      this.$confirm("正在进行删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let params = {
            action: "delete",
            tid: _data.tid
          };
          const loading = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });
          this.$axios
            .Postdata("manage/Voicerecordreport.asmx/addSentence", {
              data: JSON.stringify(this.$Help(params))
            })
            .then(res => {
              loading.close();
              console.log(res);
              if (res.data.errcode == 0) {
                this.getSentenceFun();
                this.$message({
                  showClose: true,
                  message: "操作成功",
                  duration: 2000,
                  type: "success"
                });
              } else {
                this.$message({
                  message: res.data.errmsg,
                  duration: 2000,
                  type: "error"
                });
              }
            });
        })
        .catch(() => {});
    },

    // 获取句意
    getSentenceFun() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let data = {
        sentence: this.keys,
        vtype: this.vtype,
        replaceword: this.replaceword,
        pageindex: this.pageindex,
        pagesize: this.pagesize
      };
      this.$axios
        .Postdata("manage/Voicerecordreport.asmx/getSentence", {
          data: JSON.stringify(this.$Help(data))
        })
        .then(res => {
          loading.close();
          this.tableData = res.data.detail;
          this.idDel = this.tableData.map(item => {
            item.isdel = false;
            return item;
          });
          this.allCount = res.data.totalcount;
        });
    },
    // 获取词槽
    getWordsFun() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let data = {
        keyword: "",
        pageindex: 0,
        pagesize: "0"
      };
      this.$axios
        .Postdata("manage/Voicerecordreport.asmx/getWords", {
          data: JSON.stringify(this.$Help(data))
        })
        .then(res => {
          loading.close();
          this.keywordsList = res.data.detail;
        });
    },
    // 新增句意
    addSentenceFun() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let replaceword = "";
      this.EditObj.list.forEach((element, index) => {
        if (index == this.EditObj.list.length - 1) {
          replaceword += `${element.keyword}`;
        } else {
          replaceword += `${element.keyword}(${element.count})`;
        }
      });
      let data = {
        tid: this.EditObj.tid,
        sentence: this.EditObj.sentence,
        vtype: this.EditObj.vtype,
        scode: this.EditObj.scode,
        replaceword: replaceword,
        // sort: this.EditObj.sort ? "1" : "0"
      };
      this.$axios
        .Postdata("manage/Voicerecordreport.asmx/addSentence", {
          data: JSON.stringify(this.$Help(data))
        })
        .then(res => {
          loading.close();
          console.log(res);
          loading.close();
          if (res.data.tid) {
            this.$message({
              showClose: true,
              message: "成功",
              duration: 2000,
              type: "success",
              onClose: res => {
                this.dialogTableVisible = false;
                this.getSentenceFun();
              }
            });
          }
        });
    },

    // 新增句意
    addSentenceListFun(list) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let data = {
        action: "addmulti",
        addmulti: list
      };
      this.$axios
        .Postdata("manage/Voicerecordreport.asmx/addSentence", {
          data: JSON.stringify(this.$Help(data))
        })
        .then(res => {
          loading.close();
          console.log(res);
          loading.close();
          if (res.data.errercode == 0) {
            console.log("daoru");
            this.getSentenceFun();
          }
        });
    }
  },
  created() {
    this.getSentenceFun();
    // 获取词槽
    this.getWordsFun();
    this.getvtypeList();
  }
};
</script>
<style scoped>
.ContentCss {
  padding: 8px;
  box-sizing: border-box;
}

.FIEX {
  display: flex;
  justify-content: space-between;
}

.DialogCss .el-form-item {
  margin-bottom: 5px;
}
</style>
